import { render, staticRenderFns } from "./NotAccidentPagination.vue?vue&type=template&id=4999b406&"
import script from "./NotAccidentPagination.vue?vue&type=script&lang=js&"
export * from "./NotAccidentPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports